import { motion } from "framer-motion";
import { FileEdit, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CONTACT_DISPLAY_PHONE, CONTACT_NAME } from "./kursusConstants";

const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });

const FINAL_IMG = "https://images.unsplash.com/photo-1728232032054-1546e634f03c?crop=entropy&cs=srgb&fm=jpg&q=85";

export function FinalCTA() {
  return (
    <section data-testid="kursus-final-cta" className="relative py-24 sm:py-32 overflow-hidden bg-kursus-bg">
      <div className="absolute inset-0">
        <img src={FINAL_IMG} alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-kursus-bg via-kursus-bg/85 to-kursus-bg/60" />
      </div>
      <div className="kursus-tactical-grid" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-5xl text-kursus-white leading-tight mb-4"
        >
          JANGAN JADI PELINDUNG<br /><span className="text-kursus-gold">TANPA LATIHAN.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="font-oswald uppercase text-base sm:text-xl text-kursus-red tracking-wide mb-10"
        >
          SALAH LANGKAH, <span className="text-kursus-white">NYAWA BOLEH TERGADAI.</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <Button
            data-testid="kursus-final-cta-btn"
            onClick={() => scrollTo("#daftar")}
            className="bg-kursus-gold hover:bg-kursus-goldbright text-black font-oswald font-bold tracking-wide px-8 py-6 rounded-md text-base gap-2 mb-6"
          >
            <FileEdit className="w-4 h-4" /> DAFTAR SEKARANG
          </Button>
          <div className="flex items-center justify-center gap-2 text-kursus-white font-oswald text-base sm:text-lg">
            <Phone className="w-4 h-4 text-kursus-gold" /> {CONTACT_DISPLAY_PHONE} — {CONTACT_NAME.toUpperCase()}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
